import React, { FC, Suspense, useEffect, useState } from 'react';
import { Canvas, useLoader } from '@react-three/fiber';
import { OrbitControls, Stage } from '@react-three/drei';
import { GLTFLoader } from 'three-stdlib';
import Box from '@mui/material/Box';
import QRCode from 'qrcode';
import Link from 'next/link';

type ModelViewerProps = {
	modelPath: string, // path to the 3D model file
	width?: string,
	height?: string,
	set_open_loadingScreen: (newStatus: boolean) => void,
};
const ModelViewer: FC<ModelViewerProps> = (props) => {
	// After adding <Suspense>, the zoom in after loading not work. Add this to solve this problem.
	const [refresh, set_refresh] = useState(0);
	const [arPath, set_arPath] = useState<string>(null);
	const [arPathQRCodeBase64, set_arPathQRCodeBase64] = useState<string>(null);

	useEffect(() => {
		const core = async () => {
			const _arPath = getMobileARPath(props.modelPath);
			const _arPathQRCodeBase64 = await QRCode.toDataURL(_arPath);
			set_arPath(_arPath);
			set_arPathQRCodeBase64(_arPathQRCodeBase64);
		}

		core();
	}, []);


	return (
		<Box sx={{ width: props.width ?? "90vw", height: props.height ?? "90dvh", position: "relative" }}>
			<Canvas key={refresh}>
				<ambientLight intensity={0.4} />
				<spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} />
				<pointLight position={[-10, -10, -10]} />
				<Stage>
					<Suspense fallback={<FallbackComponent set_open_loadingScreen={props.set_open_loadingScreen} set_refresh={set_refresh} />}>
						<Model path={props.modelPath} />
					</Suspense>
				</Stage>
				<OrbitControls />
			</Canvas>
			{arPath && <Box sx={{ position: "absolute", right: "10px", bottom: "10px" }}>
				<Link href={arPath as any} target='_blank'>
					<Box
						component="img"
						src={arPathQRCodeBase64}
					/>
				</Link>
			</Box>}
		</Box>
	);
};

export function getMobileARPath(modelPath: string) {
	const url = new URL(window.location.href);
	const arPath = `${url.origin}/ar?file=${encodeURI(modelPath)}`;
	return arPath;
}

type ModelProps = {
	path: string,
};
const Model: React.FC<ModelProps> = ({ path }) => {
	const gltf = useLoader(GLTFLoader, path);

	return <primitive object={gltf.scene} dispose={null} />;
};

export default ModelViewer;


type FallbackComponentProps = {
	set_open_loadingScreen: (newStatus: boolean) => void,
	set_refresh: React.Dispatch<React.SetStateAction<number>>
}
const FallbackComponent: React.FC<FallbackComponentProps> = (props) => {
	useEffect(() => {
		props.set_open_loadingScreen(true);
		return () => {
			props.set_open_loadingScreen(false);
			props.set_refresh(old => old + 1);
		}
	}, []);

	return null;
}